import { createSelector } from 'reselect';
import { IOtpSubdomain } from './model';

// Root selector for the OTP subdomain
export const otpDomain = (state: any): IOtpSubdomain => state.otp;

// Form selectors
export const otpFormSelector = createSelector(
  otpDomain,
  (subdomain: IOtpSubdomain) => subdomain.form
);

export const otpEmailSelector = createSelector(
  otpFormSelector,
  form => form.email
);

// Requests selectors
export const otpRequestsSelector = createSelector(
  otpDomain,
  (subdomain: IOtpSubdomain) => subdomain.requests
);

export const sendOtpEmailRequestSelector = createSelector(
  otpRequestsSelector,
  requests => requests.sendEmail
);

export const sendOtpEmailStatusCodeSelector = createSelector(
  sendOtpEmailRequestSelector,
  sendEmail => sendEmail.statusCode
);

export const sendOtpEmailRequestStatusSelector = createSelector(
  sendOtpEmailRequestSelector,
  sendEmail => sendEmail.request
);

export const sendOtpEmailErrorsSelector = createSelector(
  sendOtpEmailRequestSelector,
  verifyOtp => verifyOtp.errors
);

export const verifyOtpRequestSelector = createSelector(
  otpRequestsSelector,
  requests => requests.verifyOtp
);

export const verifyOtpStatusCodeSelector = createSelector(
  verifyOtpRequestSelector,
  verifyOtp => verifyOtp.statusCode
);

export const verifyOtpRequestStatusSelector = createSelector(
  verifyOtpRequestSelector,
  verifyOtp => verifyOtp.request
);

export const verifyOtpErrorsSelector = createSelector(
  verifyOtpRequestSelector,
  verifyOtp => verifyOtp.errors
);

export const resendOtpTimerSelector = createSelector(
  otpDomain,
  (subdomain: IOtpSubdomain) => subdomain.resendTimer
);

export const otpCodeSelector = createSelector(
  otpFormSelector,
  form => form.otp
);